/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Menu_MentionInputs */



/**
* | output |
* | --- |
* | "Mention a space or file" |
*
* @param {Chat_Attach_Menu_MentionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_attach_menu_mention = /** @type {((inputs?: Chat_Attach_Menu_MentionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Menu_MentionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space oder Datei erwähnen")
	return /** @type {LocalizedString} */ ("Mention a space or file")
});